import { defineRouting } from "@trydig/next/i18n";
import { defineNavigation } from "@trydig/next/i18n/navigation";
import { dedupeArray, removeTrailingSlash } from "@trydig/utils";
import { countryCodes } from "~/generated/countries";
import { getBaseUrl } from "~/lib/utils/getBaseUrl";

export const LANGUAGES = [...new Set(countryCodes.map(c => c.language))];

export const countries = countryCodes;

export const localesWithCountries = LANGUAGES.flatMap((locale) => {
	return countryCodes.map((country) => `${locale}-${country.country}`);
});

export const seoLocales = ["nb-NO"];

export const sitemapLocales = dedupeArray([
	...localesWithCountries.filter((locale) => locale.startsWith("en-")),
	...countries.map((country) => `${country.language}-${country.country}`),
]);

export const routing = defineRouting({
	languages: LANGUAGES,
	defaultLocale: "nb-NO",
	locales: localesWithCountries,
	localePrefix: "as-needed",
	/**
	 * Sets the preferred countries when multiple countries are available for a language
	 */
	groups: [
		"produkter",
		"produkt",
		"produkt/oppskrifter",
		"pages",
		"artikler",
		"kolleksjoner",
		"kolleksjon",
		"pages",
	],
	seoLocales,
	removeSegments: ["home", "produkter", "produkt", ...LANGUAGES],
});

export const {
	Link,
	Form,
	permanentRedirect,
	redirect,
	usePathname,
	useRouter,
	useGeo,
	SearchParamLink,
	addLocale,
} = defineNavigation(routing);

export const withDomain = (locale: string) => {
	return removeTrailingSlash(`${getBaseUrl()}${locale}`);
};
